/**
 * After a live call ends, clients go to Review; consultants go to Details.
 * Infer role from the appointment when roleCode is missing/stale (#24).
 */
export function resolveCallExitPath({
  appointmentId,
  roleCode,
  myId,
  appointment = {},
  free = false,
} = {}) {
  if (!appointmentId) return "/appointments";
  let role = roleCode;
  if (!role) {
    const clientId = String(
      appointment?.clientId || appointment?.callerData?.user?.id || "",
    );
    if (myId && clientId && String(myId) === String(clientId)) role = "user";
  }
  if (role === "user" && !free) {
    return `/review-appointment/${appointmentId}`;
  }
  return `/appointments-details/${appointmentId}`;
}

export default resolveCallExitPath;
